var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notificationUnreadCount)?_c('span',{staticClass:"notification-count"},[_vm._v(_vm._s(_vm.notificationUnreadCount))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }